import { useEffect, useState } from "react";
import { enforcedKioskPath, readKioskLock } from "./kiosk-lock";
import { CheckinPage } from "./pages/CheckinPage";
import { ClaimPage } from "./pages/ClaimPage";
import { DisplayPage } from "./pages/DisplayPage";
import { InstructorPage, InstructorSessionPage } from "./pages/InstructorPage";
import { KioskPage } from "./pages/KioskPage";
import { MemberPage } from "./pages/MemberPage";
import { PreviewPage } from "./pages/PreviewPage";
import { RebindPage } from "./pages/RebindPage";
import { StaffHomePage } from "./pages/StaffHomePage";
import { UnsubscribePage } from "./pages/UnsubscribePage";
import { resolveStaffHostRoute } from "./app-routing";

const legacyRoutes: Record<string, string> = {
  "/checkin.html": "/check-in", "/student.html": "/", "/member.html": "/me", "/admin.html": "/admin",
};
function currentPath() { return window.location.pathname.replace(/\/+$/, "") || "/"; }
function routeId(path: string, prefix: string) { return decodeURIComponent(path.slice(prefix.length)); }

export function App() {
  const [path, setPath] = useState(currentPath);
  useEffect(() => {
    const changed = () => setPath(currentPath());
    window.addEventListener("popstate", changed);
    return () => window.removeEventListener("popstate", changed);
  }, []);

  const lockedPath = enforcedKioskPath(path);
  const locked = readKioskLock();
  if (lockedPath && locked) return <KioskPage anchorSessionId={locked.anchorSessionId} />;
  const kioskPrefix = "/admin/kiosk/";
  if (path.startsWith(kioskPrefix)) return <KioskPage anchorSessionId={routeId(path, kioskPrefix)} />;
  const staffHostRoute = resolveStaffHostRoute(path, window.location.hostname);
  if (staffHostRoute?.kind === "instructor-home") return <InstructorPage />;
  if (staffHostRoute?.kind === "instructor-session") return <InstructorSessionPage sessionId={staffHostRoute.sessionId} />;
  if (staffHostRoute?.kind === "staff-home") {
    if (path !== staffHostRoute.canonicalPath) {
      history.replaceState(null, "", staffHostRoute.canonicalPath + window.location.search + window.location.hash);
    }
    return <StaffHomePage />;
  }
  const legacyTarget = legacyRoutes[path];
  if (legacyTarget) { window.location.replace(legacyTarget + window.location.search + window.location.hash); return null; }
  if (path === "/" || path === "/check-in") return <CheckinPage />;
  if (path === "/claim") return <ClaimPage />;
  if (path === "/rebind") return <RebindPage />;
  if (path === "/me") return <MemberPage />;
  if (path === "/display" || path.startsWith("/display/")) return <DisplayPage />;
  if (path === "/admin") return <StaffHomePage />;
  if (path === "/instructor") return <InstructorPage />;
  if (path.startsWith("/instructor/session/")) return <InstructorSessionPage sessionId={routeId(path, "/instructor/session/")} />;
  if (path === "/preview") return <PreviewPage />;
  if (path === "/unsubscribe") return <UnsubscribePage />;
  history.replaceState(null, "", "/" + window.location.search + window.location.hash);
  return <CheckinPage />;
}
